import { render } from "./resonance.vue?vue&type=template&id=48b74710&scoped=true"
import script from "./resonance.vue?vue&type=script&lang=js"
export * from "./resonance.vue?vue&type=script&lang=js"

import "./resonance.vue?vue&type=style&index=0&id=48b74710&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b74710"]])

export default __exports__